import React from "react";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import Measurements from "./measurements/measurements";
import Results from "./combineResults/results";
import PositionDrills from "./position-drills/positionDrills.jsx";

export default function AthleteTabs({ adjustedHeight, eventId, userAthlete }) {
  return (
    <TabGroup>
      <TabList className="flex gap-0 border-b border-gray-300 ">
        <Tab className="pb-2 px-2 xl:px-4 lg:px-4 font-medium whitespace-nowrap text-sm xl:text-base text-gray-800 focus:outline-none data-[selected]:text-blue-700 data-[selected]:border-b-4 data-[selected]:border-blue-700">
          Combine Results
        </Tab>
        <Tab className="pb-2 px-2 xl:px-4 lg:px-4 whitespace-nowrap text-gray-700 focus:outline-none data-[selected]:text-blue-700 data-[selected]:border-b-4 data-[selected]:border-blue-700">
          Measurements
        </Tab>
        <Tab className="pb-2 px-2 xl:px-4 lg:px-4 whitespace-nowrap text-gray-700 focus:outline-none data-[selected]:text-blue-700 data-[selected]:border-b-4 data-[selected]:border-blue-700">
          Position Drills
        </Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <div
            className="mt-4 pr-4 -mr-4 overflow-auto pb-4"
            style={{ height: `${adjustedHeight}px` }}
          >
            <Results eventId={eventId} athlete={userAthlete} />
          </div>
        </TabPanel>
        <TabPanel>
          <div
            className="mt-4 pr-4 -mr-4 overflow-auto"
            style={{ height: `${adjustedHeight}px` }}
          >
            <Measurements eventId={eventId} athlete={userAthlete} />
          </div>
        </TabPanel>
        <TabPanel>
          <div
            className="mt-4 pr-4 -mr-4 overflow-auto"
            style={{ height: `${adjustedHeight}px` }}
          >
            <PositionDrills eventId={eventId} athleteId={userAthlete.userId} />
          </div>
        </TabPanel>
      </TabPanels>
    </TabGroup>
  );
}
